import { faker } from '@faker-js/faker/locale/en';

export function mockUsers(length: number) {
  const createRowData = rowIndex => {
    const firstName = faker.name.firstName();
    const category = faker.name.firstName();
    const Buyer = faker.name.firstName();
    const Size = faker.name.firstName();
    const Color = faker.name.firstName();
    const Description = faker.name.firstName();
    const lastName = faker.name.lastName();
    const pcscarton = faker.name.lastName();
    // const gender = faker.name.gender(true) as 'female' | 'male';
    // const name = faker.name.findName(firstName, lastName, gender);
    const avatar = faker.image.avatar();

    const city = faker.address.city();
    const ProductType = faker.address.city();
    const street = faker.address.street();
    const email = faker.internet.email();
    const Pcode = faker.address.zipCode();
    const postcode = faker.address.zipCode();
    const height = faker.address.zipCode();
    const unit = faker.address.zipCode();
    const CBM = faker.address.zipCode();
    const Finish = faker.address.zipCode();
    const date = faker.date.birthdate();
    const phone = faker.phone.number();
    const width = faker.phone.number();
    const amount = faker.finance.amount(1000, 90000);

    const age = Math.floor(Math.random() * 30) + 18;
    const stars = Math.floor(Math.random() * 10000);
    const followers = Math.floor(Math.random() * 10000);
    const rating = 2 + Math.floor(Math.random() * 3);
    const progress = Math.floor(Math.random() * 100);

    return {
      id: rowIndex + 1,
      name,
      Buyer,
      Size,
      Pcode,
      pcscarton,
      Color,
      Description,
      ProductType,
      length,
      width,
      height,
      unit,
      CBM,
      Finish,
      firstName,
      category,
      lastName,
      avatar,
      city,
      street,
      postcode,
      email,
      phone,
      // gender,
      age,
      stars,
      followers,
      rating,
      progress,
      amount
    };
  };

  return Array.from({ length }).map((_, index) => {
    return createRowData(index);
  });
}

export function mockTreeData(options: {
  limits: number[];
  labels: string | string[] | ((layer: number, value: string, faker) => string);
  getRowData?: (layer: number, value: string) => any[];
}) {
  const { limits, labels, getRowData } = options;
  const depth = limits.length;

  const data = [];
  const mock = (list, parentValue?: string, layer = 0) => {
    const length = limits[layer];

    Array.from({ length }).forEach((_, index) => {
      const value = parentValue ? parentValue + '-' + (index + 1) : index + 1 + '';
      const children = [];
      const label = Array.isArray(labels) ? labels[layer] : labels;

      let row: any = {
        label: typeof label === 'function' ? label(layer, value, faker) : label + ' ' + value,
        value
      };

      if (getRowData) {
        row = {
          ...row,
          ...getRowData(layer, value)
        };
      }

      list.push(row);

      if (layer < depth - 1) {
        row.children = children;
        mock(children, value, layer + 1);
      }
    });
  };

  mock(data);

  return data;
}
